import React from 'react'
import Eng_banner from './eng-banner/Eng_banner'
import Eng_content from './eng-content/Eng_content'
import Custom_design from './custom-design/Custom_design'


const Enggagement = () => {
    return (
        <>
            <Eng_banner />
            <Eng_content />
            <Custom_design />
        </>
    )
}

export default Enggagement